<template>
	<div>
		<!-- 内容 -->
		<div class="contain flex">
			<div class="page-content">
				<div class="bm-wapper">
					<div class="bm-bar">
						<step-bar :active="0"></step-bar>
					</div>
					<div class="bm-content">
						<title-bar :titles="['招考报名','网上报名']"></title-bar>
						<div class="title">{{info.name}}</div>
						<div class="sub-title">诚信承诺书</div>
						<div class="content" v-html="return2Br(info.memo)"></div>
						<div class="btn-group">
							<el-button @click="gobty()">不同意</el-button>
							<el-button type="primary" @click="gonext()">同意</el-button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import StepBar from './stepbar.vue';
	import TitleBar from './titlebar.vue';
	import {
		isnull
	} from "@/assets/js/index";
	import {
		GetExamModel,
	} from "@/api/user";
	export default {
		components: {
			StepBar,
			TitleBar
		},
		data() {
			return {
				info: {},
			};
		},
		created() {
			var id = this.$route.query.id;
			if (!isnull(id)) {
				this.Getinfo(id);
			}
		},
		methods: {
			return2Br(str) {
				return str.replace(/\r?\n/g, "<br />");
			},
			gonext(e) {
				this.$router.push("zhaokaosubmit1?id=" + this.info.id)
			},
			gobty(e) {

				this.$router.push("zhaokaoInfo?id=" + this.info.id)
			},
			Getinfo(id) {
				GetExamModel({
					id: id
				}).then((res) => {
					if (res.success) {
						this.info = res.data[0];
					}
				});
			},
		},
	};
</script>
<style lang="scss" scoped>
	.contain {
		background-color: #fff;
		min-height: calc(100vh - 125px);
	}
	.page-content {
		width: 1200px;
		margin: 0 auto;
		padding: 20px 0;

		::v-deep .el-tabs__header {
			margin: 0;
		}

		::v-deep .el-tabs__item {
			padding: 0 80px;
		}
	}
	.bm-wapper {
		padding: 20px 0;
		display: flex;
	}

	.bm-bar {
		width: 220px;
	}

	.bm-content {
		flex: 1;
		padding: 0 48px;

		.title {
			color: rgba(16, 16, 16, 1);
			font-size: 15px;
			text-align: center;
			font-weight: bold;margin-top: 20px;
		}

		.sub-title {
			color: rgba(16, 16, 16, 1);
			font-size: 14px;
			text-align: center;
			padding: 5px;
			font-weight: bold;
		}

		.content {
			font-size: 14px;
			color: #333;
			padding-bottom: 80px;
			padding-top: 20px;
		}
	}

	.btn-group {
		text-align: center;
	}
</style>